import script from "./query.vue?vue&type=script&lang=ts&setup=true"
export * from "./query.vue?vue&type=script&lang=ts&setup=true"

import "./query.vue?vue&type=style&index=0&id=57e9be16&scoped=true&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e9be16"]])

export default __exports__